export default {"src":"/_next/static/media/check-circle.e962c2d4.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};